import { createSlice } from "@reduxjs/toolkit";
import { getRfpRefreshedCamapignProducts } from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";

const initialState = {
  refreshedProducts: [],
};
export const rfpRefreshedProducts = createSlice({
  name: "rfpRefreshedProducts",
  initialState,
  isRefreshLoading: false,
  reducers: {},

  extraReducers: (builder) => {
    //AI recommended products
    builder
      .addCase(getRfpRefreshedCamapignProducts.pending, (state) => {
        state.isRefreshLoading = true;
        state.error = null;
      })
      .addCase(getRfpRefreshedCamapignProducts.fulfilled, (state, action) => {
        state.isRefreshLoading = false;
        state.refreshedProducts = action.payload?.refreshed_products;
        if (action.payload.status == 1) {
          message.success(action.payload.message, 3);
        } else {
          message.error(action.payload.message, 3);
        }
      })
      .addCase(getRfpRefreshedCamapignProducts.rejected, (state, action) => {
        state.isRefreshLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default rfpRefreshedProducts.reducer;
